module.exports = ".containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}\n\n.error-alert {\n    color: #fd0000;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/planos/plano-form/plano-form.component.css
 ** module id = 717
 ** module chunks = 0
 **/